export default __webpack_public_path__ + "static/travis_ci-22072b2a9e3d7fea5cdfbb3e68715816.png";